import cfg from 'cfg';
import { requestAsync } from 'redux-query';
import moment from 'moment';
import get from 'lodash/get';
import { STORE_KEYS } from '../constants';
import { createApiFetchById } from './helpers';
import { eventsKeyBySportAndTtId, eventsKeyByDate } from 'dash-front/selectors';
import querystring from 'querystring';
const { ss2 } = cfg.apis;

export const fetchEventById = eventId => (dispatch, getState) => {
    const url = ss2 + '/events/' + eventId;
    const locale = get(getState(), ['user', 'props', 'lang']);
    return dispatch(
        createApiFetchById({
            id: eventId,
            url,
            idKey: 'eventId',
            key: STORE_KEYS.EVENTS,
            body: {
                locale
            }
        })
    );
};

export const fetchEventsByTournament = ({
    sportId,
    tournamentId,
    fromDate = moment()
        .startOf('d')
        .toJSON()
}) => {
    const tournamentPart = tournamentId ? `&ttId=${tournamentId}` : '';
    const sportPart = sportId ? `&sportId=${sportId}` : '';
    const url = `${ss2}/events-v2?fromDate=${fromDate}&limit=10${tournamentPart}${sportPart}`;
    const key = eventsKeyBySportAndTtId(sportId, tournamentId);
    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};

export const fetchRoundEventsForStageKey = (stageId, round) => `events:stage:round:${stageId}:${round}`;

export const fetchRoundEventsForStage = (stageId, round) => {
    const url = `${ss2}/events-v2?stageId=${stageId}&round=${round}`;
    const key = fetchRoundEventsForStageKey(stageId, round);
    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};

export const fetchLatestEventsForStageKey = (stageId, limit = 12) => `events:latests:${stageId}`;

export const fetchLatestEventsForStage = (stageId, limit = 12) => {
    const date = moment().startOf('day');

    const url = `${ss2}/events-v2?stageId=${stageId}&toDate=${date.format(
        'YYYY-MM-DD'
    )}&sortDirection=desc&limit=${limit}`;

    const key = fetchLatestEventsForStageKey(stageId);

    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId).reverse(),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};

export const fetchEventsKey = props => `events:${querystring.stringify(props)}`;

export const fetchEvents = props => {
    const url = `${ss2}/events-v2?${querystring.stringify(props)}`;
    const key = fetchEventsKey(props);

    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};

export const fetchComingEventsForStageKey = stageId => `events:coming:${stageId}`;

export const fetchComingEventsForStage = stageId => {
    const date = moment().startOf('day');
    const url = `${ss2}/events-v2?stageId=${stageId}&fromDate=${date.format('YYYY-MM-DD')}&sortDirection=asc&limit=12`;
    const key = fetchComingEventsForStageKey(stageId);

    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};

export const fetchEventsByDate = date => {
    const d = moment(date);
    const fromDate = d.clone().startOf('d');
    const toDate = d.clone().endOf('d');
    const url = `${ss2}/events-v2?fromDate=${fromDate.toJSON()}&toDate=${toDate.toJSON()}`;
    const key = eventsKeyByDate(date);
    return requestAsync({
        url,
        queryKey: key,
        force: true,
        transform: ({ events }) => ({
            [key]: events.map(e => e.eventId),
            events: events.reduce((acc, cur) => {
                acc[cur.eventId] = cur;
                return acc;
            }, {})
        }),
        update: {
            [key]: (prev, next) => next,
            events: (prev, next) => ({ ...prev, ...next })
        }
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/events.js
 **/